/**
 * Per-user display preferences. Currently exposes how the Task detail and Task
 * create surfaces open: the legacy full page / full-screen dialog, or a 60%
 * right-side drawer. The choice is persisted in localStorage via
 * {@link useTaskOverlay}.
 * @component
 * @returns {JSX.Element}
 */
import React from 'react';
import {
  Box,
  FormControlLabel,
  Switch,
  Typography,
} from '@mui/material';
import { useTaskOverlay } from '../../utils/TaskOverlayContext';

const PreferencesSettings = () => {
  const { displayMode, setDisplayMode } = useTaskOverlay();

  return (
    <Box sx={{ maxWidth: 640 }}>
      <Typography variant="h6" gutterBottom>
        Preferences
      </Typography>

      <Box sx={{ mt: 2 }}>
        <FormControlLabel
          control={
            <Switch
              checked={displayMode === 'drawer'}
              onChange={(e) =>
                setDisplayMode(e.target.checked ? 'drawer' : 'page')
              }
            />
          }
          label="Open tasks in a side panel"
        />
        <Typography variant="body2" color="text.secondary" sx={{ ml: 6 }}>
          When on, opening or creating a task slides in a panel covering 60% of
          the screen instead of opening a full page. The task you opened is
          highlighted in the list for a few seconds after you close the panel.
        </Typography>
      </Box>
    </Box>
  );
};

export default PreferencesSettings;
